module.exports = __webpack_public_path__ + "img/PC_06.1d44de2a.jpg";